import React from "react";
import Figure from "../Homepage/Figure";
import { Columns } from "@allxsmith/bestax-bulma";
import { getWorkTotals } from "../../utils";

function WorkTotals({
  workItems,
  allItems,
  chargeable,
  labourFieldName,
  partFieldName
}) {
  // if the item is not being done then it should not be included in the totals
  const work = allItems
    ? workItems.filter(item => item.not_being_done === false)
    : workItems.filter(item => item.not_being_done === false).filter(item => item.chargeable === chargeable);

  const totals = getWorkTotals(work, labourFieldName, partFieldName);

  return (
    <div>
      <Columns className="small-figure" isMultiline>
        <Figure label="Labour" loaded={true} value={totals[labourFieldName]} />
      </Columns>
      <Columns className="small-figure" isMultiline>
      <Figure label="Parts" loaded={true} value={totals[partFieldName]} />
    </Columns>
      <Columns className="small-figure" isMultiline>
      <Figure
        label="Total"
        loaded={true}
        value={totals[labourFieldName] + totals[partFieldName]}
      />
    </Columns>
      <Columns className="small-figure" isMultiline>
        <Figure
          label="Total Inc. VAT"
          loaded={true}
          value={(totals[labourFieldName] + totals[partFieldName]) * 1.2}
        />
      </Columns>
    </div>
  );
}

export default WorkTotals;
